import { render, staticRenderFns } from "./RecentDisruptions.vue?vue&type=template&id=05e7e040&scoped=true&"
import script from "./RecentDisruptions.vue?vue&type=script&lang=js&"
export * from "./RecentDisruptions.vue?vue&type=script&lang=js&"
import style0 from "./RecentDisruptions.vue?vue&type=style&index=0&id=05e7e040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e7e040",
  null
  
)

export default component.exports